import { PageHeader } from "@/components/StatCard";
import { TransferCallLog } from "@/components/TransferCallLog";
import { TestTransferCard } from "@/components/TestTransferCard";
import { LiveTransferQueue } from "@/components/LiveTransferQueue";
import { RoutingLog } from "@/components/RoutingLog";
import { LiveTransferLeads } from "@/components/LiveTransferLeads";
import { LtPipeline } from "@/components/LtPipeline";

export default function AdminLiveTransfers() {
  return (
    <div data-testid="admin-live-transfers-page">
      <PageHeader title="Live Transfer Calls" subtitle="Recordings of inbound and live transfer calls, and MLO refund requests." />
      <LiveTransferQueue />
      <RoutingLog />
      <LtPipeline />
      <LiveTransferLeads admin />
      <TestTransferCard />
      <TransferCallLog admin />
    </div>
  );
}
